<briefing-table [tableId]="tableId"></briefing-table>
